import { BodyBasedExpression } from '../Expression.js';
export class MinExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const body = this.getBody().evaluate(visitor);
        const left = this.getSource().evaluate(visitor, localVariables);
        return Math.min(left, body);
    }
}
//# sourceMappingURL=MinExpression.js.map